export default "__VITE_ASSET__Bzs8NdEs__"